import { ticketClient } from "@/api/ticketClient";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
import { SmsStatsReq } from "@/pbjs/xcommon/ticket_pb";
// lee 绩效接口参数
interface Options {
  pickDate?: string; // 查询时间范围
  user?: string; // 员工姓名
  userID?:string;  // 员工编号
  roleIDs?: string; // 角色ID
  itemID?: string; // 工单类型
  dimension?: any; // 查询维度
  pageIndex: number;
  pageSize: number;
}
export function smsStats(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SmsStatsReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDate(arg.pickDate);
      request.setUser(arg.user);
      request.setRoleids(arg.roleIDs);
      request.setItemid(arg.itemID);
      request.setDimensionList(arg.dimension);
      request.setUserid(arg.userID);
      let _res = await ticketClient.smsStats(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function smsStatsExport(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SmsStatsReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDate(arg.pickDate);
      request.setUser(arg.user);
      request.setRoleids(arg.roleIDs);
      request.setItemid(arg.itemID);
      request.setDimensionList(arg.dimension);
      request.setUserid(arg.userID);
      let _res = await ticketClient.smsStatsExport(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            // const res: any = response.toObject();
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
